<template>
  <!-- 路由编辑页面 -->
  <div class="container">
     <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item
          label="轮播图ID:"
          :label-width="formLabelWidth"
          v-show="bannerId"
        >
          <el-col :span="16">
            <el-input
              v-model="bannerId"

              :disabled="bannerId!=''"
            ></el-input>
            </el-col>
        </el-form-item>
        <el-form-item
          label="轮播图名称: "
          prop="bannerName"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.bannerName"
              autocomplete="off"
              maxlength="100"
              show-word-limit
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="上传图片"
          ref="uploadPic"
          prop="uploadPic"
          class="div-upload-form-item address"
          :label-width="formLabelWidth"
        >
          <div class="div-upload-container" ref="uploadBottom">
            <el-upload
              ref="upload"
              accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
              list-type="picture-card"
              action=""
              multiple
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :on-change="handleChange"
              :before-upload="handleBefore"
              :on-exceed="handleExceed"
              :file-list="fileList"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议图片尺寸: 宽*高=1920*800 (px)</div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item
          label="显示顺序: "
          prop="order"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.order"
              autocomplete="off"
              placeholder="请输入置顶顺序,数值小的在最上面,最小值为1,最大值9999"
            />
          </el-col>
        </el-form-item>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <div slot="footer" v-if="bannerId" class="dialog-button">
        <el-button type="primary" @click="handelConfirm('form',0)">
          发   布
        </el-button>
        <el-button class="confirm-button" @click="handelConfirm('form',1)"
          >保   存</el-button>
      </div>
      <div slot="footer" v-else class="dialog-button">
        <el-button type="primary" @click="handelConfirm('form',0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重   置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import bannerApi from '@/api/banner/index.js'
import Net from '@/constants'
import { mapRequestActions } from '@/utils'
export default {
  data () {
    return {
      loading: false,
      isRemove: true, // 判断上传图片是否删除
      formLabelWidth: '150px',
      dialogVisible: false,
      bannerId: this.$route.query.id || '',
      dialogImageUrl: '',
      fileList: [],
      sendFile: [],
      imageId: '',
      form: {
        bannerName: '',
        module: '',
        order: ''
      },
      rules: {
        bannerName: [
          { required: true, message: '请输入轮播图名称', trigger: 'change' },
          {
            min: 1,
            max: 100,
            message: '请输入长度1～100个字符',
            trigger: 'change'
          }
        ],
        uploadPic: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],

        order: [
          { required: true, message: '请输入排序', trigger: 'change' },
          { pattern: /^[0-9]*[1-9][0-9]*$/, message: '请输入正整数', trigger: 'change' },
          { min: 1, max: 4, message: '请输入1-9999之间的整数', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (this.bannerId) {
      this.handleBannerDetail()
    }
  },
  methods: {
    ...mapRequestActions(bannerApi),
    handelConfirm (formName, type) {
      if (this.fileList && this.fileList.length > 0) {
        this.rules.uploadPic = []
        this.$refs.uploadPic.clearValidate()
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 编辑状态 且 点击发布
          if (this.bannerId && type === 0) {
            this.upDateBannerManagerAction({
              id: this.bannerId,
              fileId: this.imageId,
              module: '1',
              status: type,
              name: this.form.bannerName,
              sort: this.form.order
            }).then(res => {
              if (res.status) {
                this.$message.success('编辑成功！')
              }
              this.$router.push('/home')
            })
          } else if (this.bannerId && type === 1) { // 编辑状态 且 点击保存
            this.upDateBannerManagerAction({
              id: this.bannerId,
              fileId: this.imageId,
              module: '1',
              status: type,
              name: this.form.bannerName,
              sort: this.form.order
            }).then(res => {
              if (res.status) {
                this.$message.success('保存成功！')
              }
              this.$router.push('/home')
            })
          } else { // 新增数据
            this.addBannerManageAction({
              fileId: this.imageId,
              module: '1',
              status: type,
              name: this.form.bannerName,
              sort: this.form.order
            }).then(res => {
              if (res.status) {
                this.$message.success('新增成功！')
              }
              this.$router.push('/home')
            })
          }
        }
      })
    },

    // 根据ID查询详情
    async handleBannerDetail () {
      const resultData = await this.getBannerDetailByIDAction({ id: this.bannerId })
      if (resultData.status) {
        // console.log('resultData.result', resultData.result)
        this.form.bannerName = resultData.result.name || ''
        this.form.order = resultData.result.sort + '' || ''
        if (resultData.result.file) {
          this.fileList.push({ name: this.form.bannerName, url: Net.baseUrl + resultData.result.file.relativePath })
        }
      }
    },
    /**
     * 新建页面 -- 重置按钮
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.$refs.upload.clearFiles()
      this.fileList = []
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
      } else {
        const index = this.fileList.findIndex(item => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
        if (this.sendFile && this.sendFile.length === 0) {
          this.rules.uploadPic = [
            { required: true, message: '请上传图片', trigger: 'change' }
          ]
          this.$refs.form.validateField('uploadPic')
        }
      }
    },
    handleChange (file) {

    },

    handleBefore (file) {
      this.$refs.uploadPic.clearValidate()
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)
      const that = this
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach(element => {
          formData.append('file', element)
        })
        formData.append('bizeType', '首页banner')
        that.upLoadDataAction(formData).then(res => {
          if (res.status) {
            that.imageId = res.result.id || ''
          }
        })
        image.src = data
        if (that.sendFile.length > 0) {
          this.hasFmt = true
        }
      }
      return false
    },

    handleExceed () {
      this.$message.warning('最多可以上传1张图片')
    }
  }
}
</script>

<style lang='less' scoped>
.container{
  padding:10px;
}
.el-form {
  max-width: 80%;
  min-width: 800px;
  margin-right: auto;
  padding: 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  .address {
    /deep/ .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 150px;
    float: left;
    // overflow: hidden;
    text-align: left;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
    .el-upload__tip{
      margin-top: 0;
      line-height: 26px;
      padding-bottom: 5px;
    }
  }
}
.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;margin-left: 20%;margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
</style>
